import React, { useState } from "react";
import cx from "classnames";
import styles from "./RefluxMonitoring.module.css";

/**
 * Individual subscriber row with expandable raw stack trace.
 * @param {Object} props
 * @param {Object} props.sub - Subscriber object with id, age, location, rawStack
 * @param {Function} props.formatAge - Function to format age in human-readable format
 */
const SubscriberRow = ({ sub, formatAge }) => {
  const [expanded, setExpanded] = useState(false);
  const hasStack = !!sub.rawStack;
  const isFiltered = sub.location === "(filtered)";
  const needsExpansion = hasStack && (!sub.location || isFiltered);

  return (
    <div>
      <div
        className={cx(styles.subscriberRow, {
          [styles.subscriberRowClickable]: hasStack,
          [styles.subscriberRowExpanded]: expanded,
        })}
        onClick={() => hasStack && setExpanded(!expanded)}
        onKeyDown={(e) => hasStack && e.key === "Enter" && setExpanded(!expanded)}
        role={hasStack ? "button" : undefined}
        tabIndex={hasStack ? 0 : undefined}
      >
        <span className={styles.colAge}>{formatAge(sub.age)}</span>
        <span
          className={cx(styles.colLocation, {
            [styles.colLocationMissing]: !sub.location,
            [styles.colLocationNeedsExpansion]: needsExpansion,
          })}
        >
          {sub.location || "(pre-DevTools)"}
          {hasStack && <span className={styles.expandArrow}>{expanded ? "▼" : "▶"}</span>}
        </span>
      </div>
      {expanded && sub.rawStack && (
        <div className={styles.rawStack} onClick={(e) => e.stopPropagation()}>
          {sub.rawStack.replace(/^Error\n/, "")}
        </div>
      )}
    </div>
  );
};

export default SubscriberRow;
